import { acceptHMRUpdate, defineStore } from 'pinia';

export const useProductionStore = defineStore('production', {
  state: () => ({
    selectedAccessDevice: null,
    boxCountList: null,
  }),

  persist: true,
});

if (import.meta.webpackHot) {
  import.meta.webpackHot.accept(acceptHMRUpdate(useProductionStore, import.meta.webpackHot));
}
